module.exports = __webpack_public_path__ + "img/dashboard-landing-other-status.cf8c706e.svg";